import styled from "styled-components";

const FormInputGroup = styled.div.attrs({ role: "group" })`
  display: flex;
`;

export default FormInputGroup;
